var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.262 26.99c.044.59.044 1.178.044 1.765 0 17.972-13.679 38.68-38.677 38.68-7.702 0-14.857-2.23-20.878-6.105 1.093.125 2.146.17 3.284.17a27.236 27.236 0 0016.878-5.81 13.62 13.62 0 01-12.714-9.426c.84.125 1.684.21 2.569.21 1.218 0 2.443-.17 3.58-.463a13.59 13.59 0 01-10.9-13.341v-.17a13.718 13.718 0 006.142 1.725 13.575 13.575 0 01-6.062-11.32c0-2.524.672-4.84 1.85-6.858A38.667 38.667 0 0039.41 30.274a15.451 15.451 0 01-.338-3.115 13.587 13.587 0 0113.595-13.595c3.915 0 7.448 1.64 9.932 4.293a26.856 26.856 0 008.627-3.284 13.567 13.567 0 01-5.977 7.493 27.245 27.245 0 007.826-2.106 29.176 29.176 0 01-6.814 7.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.8fb9db2d83aa4c716740fcae3dc63494.svg";
export { ForwardRef as ReactComponent };